import React, { useState, useEffect } from 'react';

import { getOrFetchHeaderData } from '@/utils/headerCalls';
import SelectStorePage from '@/components/SelectStorePage/SelectStorePage';
import { getOrFetchConfiguration } from '@/utils/getConfiguration';
import LoginLayout from '@/components/LoginLayout/LoginLayout';
import { getLayoutProps } from '@/utils/layout/layout';

export default function SelectStore({ loginConfig, loginImage, responsiveLogo }) {
  const [config, setConfig] = useState();
  loginImage === '' ? (loginConfig = 0) : null;

  useEffect(() => {
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
      return;
    }
    getConfiguration();
  }, []);
  return (
    <>
      {config && (
        <LoginLayout type={loginConfig} image={loginImage} responsiveLogo={responsiveLogo}>
          <SelectStorePage responsiveLogo={responsiveLogo} />
        </LoginLayout>
      )}
    </>
  );
}

export async function getStaticProps(context) {
  const { responsiveLogo } = await getLayoutProps({ headerProps: { selectedIndex: 0 } }, context.locale);

  const [{ data: loginAllData }] = await Promise.all([getOrFetchHeaderData('login_page', context.locale)]);
  const loginConfig = loginAllData.data[0].content.configuration;
  const loginImage = loginAllData.data[0].content.image?.url ? loginAllData.data[0].content.image?.url : '';

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
    login_register: (await import(`../../../prebuild-data/i18n/${context.locale}/login_register.json`)).default,
  };

  return {
    props: {
      responsiveLogo,
      loginConfig,
      loginImage,
      messages,
    },
  };
}
